module.exports = __webpack_public_path__ + "static/img/baidu.8533bfe6.svg";